<!-- 投放作品 -->
<template>
<div>
	<a-select
		:style="{'width': s_width}" 
		:placeholder="`请选择${s_placeholder || ''}`"
		notFoundContent="请先选择对应渠道"
		:filter-option="false"
		@change="handleChangeS"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="popupScrollCEshi" 
		showSearch
		:allowClear="page_type == 'gzhFans'?false : true"
		@search="selectZhSearch"
		:not-found-content="s_fetching ? undefined : null" 
		@blur="zhBlur" 
		:value="select_value"
	  >
		<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
		<!-- <a-select-option v-for="(item,index) in showFilterData" :key="item.id" :value="item.id">
		  {{item.gzh_name}}
		</a-select-option> -->
		<a-select-option v-for="(item,index) in showFilterData" :key="item.id" :value="item.id" :title="`${item.book_name}（ID：${item.id}  ${item.channel_name}）`">
		  {{item.book_name}}<span>（ID：{{item.id}}  {{item.channel_name}}）</span>
		</a-select-option>
		<a-select-option v-if="loading_more_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
	
</div>
</template>

<script>
import { bookPutList, getBookList } from '@/request/api'
export default {
	name: 'tfBookSelect_',
	props: ['page_type','s_width','s_placeholder',],
	data(){
		return {
			select_value: [], // 选择的广告账户
			showFilterData: [], // 选择广告账户
			s_page: 1,
			s_limit: 100,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			showFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			r_type: "",
			r_q: "",
			r_channel_id: null,
			r_product_type: null,
		}
	},
	mounted(){
		// console.log("page-type",this.page_type)
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		getSelectData(e,type){
			let that = this
			
			if(type == 'clear'){ // 清空已选中内容
				that.select_value = undefined
			}
			
			that.r_q = e || undefined
			that.r_channel_id = e || undefined
			
			that.selecrReq()
		},
		selecrReq(){
			let that = this
			getBookList({
				page: 1,
				limit: that.s_limit,
				
				channel_id: that.r_channel_id,
				product_type: that.r_product_type,
			}).then(res=>{
				console.log("投放作品",res)
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.showFilterData = res.data.data.data || []
					
					// that.showFilterData = res.data.slice(that.s_page, that.s_limit)
					// that.showFilterSearch = res.data
					that.showFilterBlur = res.data.data.data || []
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
		},
		changeType(e){
			let that = this
			that.r_product_type = e
			that.selecrReq()
		},
		clearValue(){
			this.select_value = undefined
		},
		getClose(){
			this.select_value = undefined
		},
		getEdit(b_id,eee){
			this.select_value = b_id || undefined
			this.r_product_type = eee || undefined
			this.selecrReq()
		},
		handleChangeS(value) {
			console.log("handleChangeS",value);
			
			this.select_value = value
			this.$emit('handleChangeSelect', value)
			
		},
		
		popupScrollCEshi(e){ // 上拉触底加载更多
			// console.log("上拉触底加载更多",e);
			// console.log(e.target.scrollTop);
			// console.log(e.target.scrollHeight - e.target.scrollTop);
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					// console.log("上拉触底加载更多");
					getBookList({
						page: that.s_page,
						limit: that.s_limit,
						book_name: that.s_adv_name,
						
						channel_id: that.r_q,
						product_type: that.r_product_type,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.showFilterData 
						that.loading_more_hint = false
						that.s_fetching = false
						
						if(that.showFilterData.length < res.data.data.total){
							that.showFilterData = data.concat(res.data.data.data)
							that.loading_more_control = true
						}
					})
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.showFilterData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			getBookList({
				page: 1,
				limit: that.s_limit,
				channel_id: that.r_q,
				book_name: e,
				product_type: that.r_product_type,
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.showFilterData = res.data.data.data
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.showFilterData = that.showFilterBlur 
			that.loading_more_control = true
		},
	}
}
</script>

<style scoped>
.page-true {
	width: 100%;
}
.page-false {
	min-width: 300px;
	max-width: 1300px;
}
</style>